import axios from "axios";

import { API_CALL_URL } from "../constants";

export type SubTagApiResponse = {
  id: string;
  subTagName: string;
  createdAt: Date;
  updatedAt: Date;
};

export type SubTagUpdateRequest = {
  id: string;
  subTagName: string;
};

export const fetchSubTag = async (): Promise<SubTagApiResponse[]> => {
  try {
    const response = await axios.get<SubTagApiResponse[]>(`${API_CALL_URL}/sub-tag`);
    return response.data;
  } catch (error) {
    console.error("Axios error:", error);
    return [];
  }
};

export const updateSubTag = async ({
  id,
  subTagName,
}: SubTagUpdateRequest): Promise<SubTagApiResponse | undefined> => {
  try {
    const response = await axios.put<SubTagApiResponse>(`${API_CALL_URL}/sub-tag`, {
      id,
      subTagName,
    });
    return response.data;
  } catch (error) {
    console.error("Axios error:", error);
    return undefined;
  }
};

export const createSubTag = async ({
  subTagName,
}: {
  subTagName: string;
}): Promise<SubTagApiResponse | undefined> => {
  try {
    const response = await axios.post<SubTagApiResponse>(`${API_CALL_URL}/sub-tag`, {
      subTagName,
    });
    return response.data;
  } catch (error) {
    console.error("Axios error:", error);
    return undefined;
  }
};

export const deleteSubTag = async ({ id }: { id: string }): Promise<boolean> => {
  try {
    await axios.delete(`${API_CALL_URL}/sub-tag/${id}`);
    return true;
  } catch (error) {
    console.error("Axios error:", error);
    return false;
  }
};
